import {
    Box,
    Grid,
    styled,
    Typography,
    Paper,
    Avatar,
    Button,
    Chip,
    CircularProgress,
    Card,
    Rating,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import TitleCase from '../BasicComponents/TitleCase';
import { useHistory, useRouteMatch } from 'react-router-dom';

const TeacherResultsContainerBox = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridGap: '20px',
    gridRowGap: 0,
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 300px))',
    justifyContent: 'center',
    alignItems: 'center',
}));

const TeacherResultsCard = styled(Card)(({ theme }) => ({
    width: '100%',
    margin: '20px auto',
    boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
    borderRadius: '10px',
    '&:hover, &:focus, &:active': {
        position: 'relative',
        top: '-5px',
        cursor: 'pointer',
        border: `1px solid ${theme.palette.primary.main}`,
    },
}));

const TeacherImgContainer = styled('div')(({ theme }) => ({
    margin: 'auto',
    width: '80px',
    textAlign: 'center',
}));

const TeacherImg = styled('img')(({ theme }) => ({
    width: '100%',
    height: 'auto',
    borderRadius: '50%',
}));

const TeacherInfoType = styled('div')(({ theme }) => ({
    margin: '12px',
}));

const TeacherSubmissions = props => {
    let history = useHistory();
    let match = useRouteMatch();

    const HeadingBox = styled(Box)(({ theme }) => ({
        backgroundColor:
            props.submission.submission.status === 'Contacted'
                ? theme.palette.primary.light
                : props.submission.submission.status === 'ShortListed'
                ? theme.palette.forth.dark
                : props.submission.submission.status === 'Rejected'
                ? theme.palette.sexyerror.main
                : theme.palette.secondary.light,
        padding: '3px 12px 3px 12px',
    }));

    return (
        <TeacherResultsContainerBox
            sx={{ margin: '8px' }}
            key={`/${props.submission.submission['gs1-pk']}/${props.submission.user.uniqueId}`}
            onClick={() => {
                history.push(
                    match.path +
                        `/${props.submission.submission['gs1-pk']}/${props.submission.user.uniqueId}`
                );
            }}
        >
            <TeacherResultsCard data-cy="teacherTile">
                <HeadingBox>
                    <Typography sx={{ color: '#FFFFFF' }}>
                        {props.submission.submission.status === 'NotAssessed'
                            ? 'Not assessed'
                            : props.submission.submission.status ===
                              'ShortListed'
                            ? 'Short listed'
                            : props.submission.submission.status}
                    </Typography>
                </HeadingBox>
                <Grid
                    container
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        margin: '12px',
                    }}
                >
                    <Grid item>
                        <Grid container>
                            <Grid item sx={{ marginRight: '8px' }}>
                                <TeacherImgContainer>
                                    <TeacherImg
                                        src={props.submission.user.profileImage}
                                    />
                                </TeacherImgContainer>
                            </Grid>
                            <Grid>
                                <TitleCase
                                    variant="h3"
                                    string={
                                        props.submission.user.firstName +
                                        ' ' +
                                        props.submission.user.lastName
                                    }
                                    data-cy="teacherTileName"
                                />
                                {props.submission.user.rating ? (
                                    <>
                                        <Rating
                                            name="simple-controlled"
                                            value={props.submission.user.rating}
                                            readOnly
                                            precision={0.5}
                                        ></Rating>
                                        <Typography>
                                            {`/ ${props.submission.user.amountOfRatings} reviews`}
                                        </Typography>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography
                    variant="body2"
                    sx={{ marginTop: '8px', margin: '12px' }}
                >
                    {`${props.submission.submission.description.substring(
                        0,
                        100
                    )}${
                        props.submission.submission.description.length > 100
                            ? '...'
                            : ''
                    }`}
                </Typography>

                <TeacherInfoType>
                    {props.submission.user.grades === undefined ? (
                        <Typography variant="body1">
                            No Allocated Grades
                        </Typography>
                    ) : (
                        props.submission.user.grades.map((grade, index) => (
                            <Typography variant="body1" key={index}>
                                {grade}
                            </Typography>
                        ))
                    )}
                </TeacherInfoType>
                <Box sx={{ margin: '12px' }}>
                    {props.submission.user.skills === undefined ? (
                        <></>
                    ) : (
                        props.submission.user.skills.map((skill, index) => {
                            {
                                return <Chip key={index} label={skill} />;
                            }
                        })
                    )}
                </Box>
            </TeacherResultsCard>
        </TeacherResultsContainerBox>
    );
};

export default TeacherSubmissions;
